import { useState } from 'react';
import { FileText } from 'lucide-react';
import {
  realtyButtonsTitles,
  realtyInfoButtons,
} from '../../../../data/cardRealty';
import {
  colors,
  mockAccordionTitles,
  successMessages,
} from '../../../../data/constants';
import { formatNumberDisplay, handleCopy } from '../../../../utils/utils';
import { AddOwnerComment } from '../../../form/forms/realtyCardForms/AddOwnerComment';
import { ButtonTemplate } from '../../buttons/ButtonTemplate';
import { IconButtonTemplate } from '../../buttons/IconButtonTemplate';
import { Dialog } from '../../Dialog';
import { RealtyFormDialog } from '../RealtyDetailsDialog';

export const InfoButtons = ({ realty = {}, canEdit = false }) => {
  const [isEditOwnerOpen, setIsEditOwnerOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isEditPriceOpen, setIsEditPriceOpen] = useState(false);

  const { tariff, id, main } = realty;
  const tariff_is_drop = tariff?.tariff_is_drop;
  const tariff_price = tariff?.tariff_price;
  const living_area = main?.living_area;

  const pricePerMeter =
    tariff_price && living_area ? Math.round(tariff_price / living_area) : null;

  const buttonsText = {
    [realtyButtonsTitles.copy]: `${id}`,
    [realtyButtonsTitles.editPrice]: tariff_price
      ? `${formatNumberDisplay(tariff_price)} €, (${pricePerMeter ? formatNumberDisplay(pricePerMeter) : 'N/A'} € / m²)`
      : '',
  };

  const handleInfoClick = () => {
    setIsEditOwnerOpen(!isEditOwnerOpen);
  };

  const handleEditClick = () => {
    setIsEditOpen(!isEditOpen);
  };

  const handleCopyClick = () => {
    handleCopy(
      `${window.location.origin}/?realtyId=${id}`,
      successMessages.copyLink
    );
  };

  const handleEditPriceClick = () => {
    setIsEditPriceOpen(!isEditPriceOpen);
  };

  const buttonsHandlers = {
    [realtyButtonsTitles.info]: handleInfoClick,
    [realtyButtonsTitles.edit]: handleEditClick,
    [realtyButtonsTitles.copy]: handleCopyClick,
    [realtyButtonsTitles.editPrice]: handleEditPriceClick,
  };

  return (
    <>
      <div className="flex gap-1.5 w-full">
        {realtyInfoButtons.map(button => {
          const isEditPrice = button.title === realtyButtonsTitles.editPrice;
          const isDetails = !canEdit && button.title === realtyButtonsTitles.edit;

          return button.hasText && buttonsText[button.title] ? (
            <ButtonTemplate
              key={button.id}
              handleClick={buttonsHandlers[button.title]}
              text={buttonsText[button.title]}
              classes={button.classes}
              isSmallText={true}
              isIconText={
                (isEditPrice && tariff_is_drop) || button?.isIconText
                  ? true
                  : false
              }
              icon={
                (isEditPrice && tariff_is_drop) || (!isEditPrice && button.icon)
                  ? button.icon
                  : null
              }
              isSmall={true}
              isSmallBorder={true}
              color={
                isEditPrice && tariff_is_drop
                  ? colors.redColor
                  : colors.blackColor
              }
              tooltipText={
                isEditPrice && !canEdit ? 'Price details' : button.tooltipText
              }
            />
          ) : (
            <IconButtonTemplate
              key={button.id}
              handleClick={buttonsHandlers[button.title]}
              icon={isDetails ? FileText : button.icon}
              classes={button.classes}
              isSmallBorder={true}
              size={16}
              tooltipText={isDetails ? 'Details' : button.tooltipText}
            />
          );
        })}
      </div>

      {isEditOwnerOpen && (
        <Dialog
          content={
            <AddOwnerComment
              realty={realty}
              handleClose={() => setIsEditOwnerOpen(false)}
            />
          }
          isOpen={isEditOwnerOpen}
          onClose={() => setIsEditOwnerOpen(false)}
        />
      )}

      {isEditOpen && (
        <RealtyFormDialog
          realty={realty}
          canEdit={canEdit}
          onClose={() => setIsEditOpen(false)}
        />
      )}

      {isEditPriceOpen && (
        <RealtyFormDialog
          realty={realty}
          canEdit={canEdit}
          section={mockAccordionTitles.Tariff}
          onClose={() => setIsEditPriceOpen(false)}
        />
      )}
    </>
  );
};
